module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/link-1280x160-aae0d66f321d3973db8e11239649b39f.webp";